import React from 'react'

/**
 * Shared search + page controls for Daily Data preview lists.
 */
export default function PreviewListToolbar({
  search,
  onSearchChange,
  searchPlaceholder = 'Search…',
  pageSize,
  onPageSizeChange,
  pageSizes = [15, 25, 50],
  offset = 0,
  pageCount = 0,
  totalMatched = 0,
  hasMore = false,
  onPrev,
  onNext,
  loading = false,
  hint = null,
}) {
  const from = totalMatched === 0 ? 0 : offset + 1
  const to = offset + pageCount

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-sm">
      <input
        type="search"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={searchPlaceholder}
        className="flex-1 min-w-[10rem] rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
      />
      {onPageSizeChange && (
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="rounded-md border border-gray-300 px-2 py-1.5 text-sm"
          title="Rows per page"
        >
          {pageSizes.map((n) => (
            <option key={n} value={n}>{n} / page</option>
          ))}
        </select>
      )}
      <div className="flex items-center gap-2 text-xs text-gray-600 whitespace-nowrap">
        <span>
          {totalMatched === 0 ? '0 matches' : `${from}–${to} of ${totalMatched}`}
        </span>
        {(onPrev || onNext) && (
          <div className="flex gap-1">
            <button
              type="button"
              disabled={loading || offset <= 0}
              onClick={onPrev}
              className="px-2 py-1 border rounded disabled:opacity-40 hover:bg-gray-50"
            >
              Prev
            </button>
            <button
              type="button"
              disabled={loading || !hasMore}
              onClick={onNext}
              className="px-2 py-1 border rounded disabled:opacity-40 hover:bg-gray-50"
            >
              Next
            </button>
          </div>
        )}
      </div>
      {hint && <p className="text-xs text-gray-500 sm:basis-full">{hint}</p>}
    </div>
  )
}
